/**
 * Global Variables (Objects)
 */

// Breakpoints
export const breakpoint = {
  xs: 0,
  sm: '768px',
  md: '1024px',
  lg: '1440px',
  xl: '1920px',
};

// Colors
export const color = {
  black: {
    one: '#6c6c72',
    two: '#525257',
    three: '#1a2832',
    nine: '#272E2B',
  },
  blue: {
    one: '#d6eff1',
    two: '#80D3DF',
    three: '#58B3CA',
    four: '#408FAD',
    five: '#142841',
  },
  gray: {
    one: '#F9F9F9',
    two: '#F5F5F5',
    three: '#D0CECE',
    four: '#A5A5A5',
    five: '#6E7071',
    six: '#404042',
    seven: '#2F3941',
  },
  green: {
    one: '#E8F7F2',
    two: '#6BD9A1',
    three: '#24A06D',
    four: '#158562',
    five: '#0B5C53',
  },
  lavender: {
    one: '#d1e1fa',
  },
  mint: {
    one: '#E9EDED',
    two: '#BCECCF',
    three: '#A3E1C2',
    four: '#77C1A3',
    five: '#007c89',
    six: '#004e56',
    nine: '#08565A',
    ten: '#375844',
  },
  pastel: {
    blue: '#c5dbf2',
    green: '#A6E1CE',
    purple: '#d1e1fa',
    orange: '#fbcfbd',
    salmon: '#f9ccbd',
    petrol: '#59809b',
    pink: '#f9e0fa',
    sand: '#efeeea',
    yellow: '#FAE9BD',
  },
  pink: {
    one: '#ffebf6',
  },
  purple: {
    one: '#F7E4F5',
    two: '#D6C0D8',
    three: '#BAA3BF',
    four: '#9877A4',
    five: '#56336E',
  },
  red: {
    one: '#FFD2D2',
    two: '#EC8E4E',
    three: '#eb923a',
    four: '#98453d',
    five: '#821907',
  },
  yellow: {
    one: '#F3ECBB',
    two: '#fed156',
    three: '#EBC627',
    four: '#EBC627',
    five: '#88690C',
  },
  white: {
    ten: '#FFFFFF',
    nine: '#fafafa',
  },
};

// Box Shadow
export const shadow = {
  base:
    '0px 1px 1px rgba(0, 0, 0, 0.08), -1px 0px 1px rgba(0, 0, 0, 0.08), 1px 0px 1px rgba(0, 0, 0, 0.08), 0px -1px 1px rgba(0, 0, 0, 0.08)',
};

// Z-Index
export const zIndex = {
  base: '0',
  xs: '10',
  sm: '25',
  md: '50',
  lg: '100',
  xl: '250',
  auto: 'auto',
};

// Fonts
export const fontfamily = {
  sans: "'Inter', sans-serif",
  serif: "'Inter', serif",
};

// Font Sizes
export const fontsize = {
  tiny: '11px',
  small: '13px',
  reg: '1rem',
  big: '18px',
  huge: '22px',
  giant: '24px',
};

// Font Sizes
export const fontweight = {
  light: '300',
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
};

export const opacity = {
  base: '1',
  quiet: '0.75',
  quieter: '0.5',
  quietest: '0.25',
};

export const width = {
  one: '8.33333%',
  two: '16.6666%',
  three: '25%',
  four: '33.3333%',
  five: '41.6666%',
  six: '50%',
  seven: '58.3333%',
  eight: '66.6666%',
  nine: '75%',
  ten: '83.3333%',
  eleven: '91.6666%',
  twelve: '100%',
};

export const maxWidth = {
  one: '24rem',
  two: '32rem',
  three: '48rem',
  four: '72rem',
};

export const spacing = {
  one: '0.5rem',
  two: '1rem',
  three: '1.5rem',
  four: '2rem',
  five: '3rem',
  six: '4rem',
  seven: '6rem',
  eight: '8rem',
  auto: 'auto',
};

export const mediaQuery = {
  xs: `(min-width: 0)`,
  sm: `(min-width: 768px)`,
  md: `(min-width: 1024px)`,
  lg: `(min-width: 1440px)`,
  xl: `(min-width: 1920px)`,
};

export const animate = {
  default: '.085s all ease-in',
  slow: '.25s all ease-in',
};

export const lineHeight = {
  one: '1',
  two: '1.125',
  three: '1.25',
  four: '1.5',
};

export const grid = {
  three:
    'display: grid;grid-auto-columns: 1fr;grid-template-columns: 1fr 1fr 1fr;grid-column-gap: 16px;grid-row-gap: 24px;',
  four:
    'display: grid;grid-auto-columns: 1fr;grid-template-columns: 1fr 1fr 1fr 1fr;grid-column-gap: 16px;grid-row-gap: 24px;',
};

export const radius = {
  base: '4px',
  lg: '8px',
};
